
import React from 'react';
import "katex/dist/katex.min.css";
import { Card } from 'primereact/card';

export default function AboutPage() {

    const player = {
        fullBodyPath: '5e94c0ed87a86a53b6b3e1f25833d877',
        nick: 'charlie_andy',
        countryCode: 'sg'
    }
    const title = (
        <a href="/player/5e7ee74c3d4b6a67cc9ca056"><img src={`https://www.geoguessr.com/images/resize:auto:300:300/gravity:ce/plain/pin/${player.fullBodyPath}.png`} style={{ position: 'absolute', 'marginLeft': '-8rem', marginTop: '2rem', height: '10rem' }}/> </a>
        );

    return (
            <div className="col-6 col-offset-3 gap-3 flex flex-column-reverse">
            
            <Card className="flex flex-column align-items-center" title={title}  style={{height: '100%'}}>
                <h1>About</h1>
                <div className="card">
                    <p>
                        Page created out of passion for GeoGuessr.
                    </p>
                    <p>
                        I'm a <a href="https://www.geoguessr.com/user/5e7ee74c3d4b6a67cc9ca056" style={{textDecoration: 'underline'}} target="_blank">GeoGuessr player named <strong>charlie_andy</strong></a>.
                    </p>
                    <p>
                        For feedback or feature requests, please message go to Discord.
                    </p>
                </div>
                <p>&nbsp;</p>
                <p class="section-detail px-0 mt-0 mb-5 text-align-center" style={{width: '100%'}}>
                    Discord georank.io invite: <code>#<a style={{textDecoration: 'underline'}} href="https://discord.gg/gKq7aJ2QEb">GeoRank.io</a></code>.
                </p>
                <p class="section-detail px-0 mt-0 mb-5 text-align-center" style={{width: '100%'}}>
                    Discord direct contact: <code>@charlieandy</code>.
                </p>
            </Card>
            </div>
    )
}